var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmtTypography',{attrs:{"as":"p1"}},[_c('CBox',{attrs:{"mt":"8px","mb":"8px"}},[_vm._v("Vamos juntos?")]),_c('strong',[_vm._v(" Omint Toda Vida."),_c('br'),_vm._v(" Juntos pela sua saúde. Agora e sempre. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }